<div class="form-group">
  <label for="prod-m">{{ 'form.attribute'| translate }}</label>
  <angular2-multiselect [data]="attributeList"
      [(ngModel)]="attributeSelected"
      [settings]="multiselectSettings_base"
      (onSelect)="onAttributeSelect()">
  </angular2-multiselect>
</div>
